module.exports = __webpack_public_path__ + "static/media/relaxing-animation.7f234bdf.webm";